module.exports = __webpack_public_path__ + "img/navbar-logo-dark.7f225aa3.png";